import React, { useEffect, useRef, useState } from 'react';
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia, Section, SignalButton, VideoShort } from '../../components/imports';
import CountUp from 'react-countup';
// import { Link } from 'react-router-dom';
import useDisplayValue from '../../hooks/useDisplayValue';
import Media from '../../components/common/Media';
import useWindowSize from '../../hooks/useWindowSize';
// import useMouse from '../../hooks/useMouse';

const Content = () => {

  const heroRef = useRef(null);
  const contentRef = useRef(null);
  const { formattingFn } = useDisplayValue("");
  const { onMobile } = useWindowSize();
  // const { toDefault, toPlay } = useMouse();
  const [contentHeight, setContentHeight] = useState(0);

  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.offsetHeight);
      console.log("Content height:", contentRef.current.offsetHeight);
    }
  }, []);

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>
          <MotionContent imgRef={heroRef} height={"110vh"} className="bg-black">
            <ImageMedia
              key={"heroJewoh"}
              src={require('./assets/hero.jpg')}
              className="relative md:landscape:scale-[125%] full object-cover object-center"
            />
          </MotionContent>

          <div className='relative flex flex-col lg:flex-row w-full items-start justify-start gap-4 h-full'>
            <div style={{ height: !onMobile ? `${contentHeight}px` : "auto" }} className='flex max-lg:portrait:w-full max-md:portrait:bg-transparent center min-w-[30vw]= relative lg:min-h-[400vh]= max-lg:portrait:mt-40 h-full md:landscape:items-start md:landscape:justify-start'>
              <div className='stickyVideo sticky top-0 flex center overflow-x-clip !aspect-[9/16]= '>
                <div className='h-[100dvh] max-lg:portrait:h-[80vh] mx-auto !aspect-[9/16] flex center relative overflow-clip w-full border border1 '>
                  <VideoShort showControls src={require('./jewoh.mov')} />
                </div>
              </div>
            </div>

            <div ref={contentRef} id="contentHeight" className='flex flex-col ==signal== w-full resp lg:!pl-0 lg:!ml-0 lg:min-h-[150vh] '>

              <Section padded className={"items-center w-full lg:pt-[40vh] h-fit bg-transparent"}>
                <div className='group text-left w-full flex flex-col padding h-fit'>
                  <h2 className='max-w-[20ch] w-fit text-balance'>Vidéo officielle de lancement <span className='capitalize'>{thisProject.client}</span>.</h2>

                  <SignalButton link={"https://www.instagram.com/jewoh_"} />

                </div>

                {/* STATS */}
                <div className='grid grid-cols-2 lg:grid-cols-4 lg:h-[100svh]= gap-6 paddingX w-full relative mt-8'>

                  <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                    <h2 className='w-[4ch]'>
                      <CountUp
                        start={1}
                        end={46000}
                        duration='2.5'
                        className='m-0 p-0'
                        scrollSpyOnce
                        enableScrollSpy
                        formattingFn={formattingFn}
                        useEasing
                      />
                    </h2>
                    <h4 className='leading-none'>vues Instagram</h4>
                  </li>
                  <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                    <h2 className='w-[4ch]'>
                      <CountUp
                        start={1}
                        end={55}
                        duration='2.5'
                        className='m-0 p-0'
                        scrollSpyOnce
                        enableScrollSpy
                        formattingFn={formattingFn}
                        useEasing
                      />
                    </h2>
                    <h4 className='leading-none'>images produites</h4>
                  </li>
                  <li className='flex flex-col gap-2 items-start h-fit pb-4 border-b border1'>
                    <h2 className='w-[4ch]'>
                      <CountUp
                        start={1}
                        end={69}
                        duration='2.5'
                        className='m-0 p-0'
                        scrollSpyOnce
                        enableScrollSpy
                        formattingFn={formattingFn}
                        useEasing
                      />
                    </h2>
                    <h4 className='leading-none'>secondes motion 3D</h4>
                  </li>
                </div>
              </Section>

              <Section padded className={"items-center w-full bg-transparent"}>
                <div className='text-left w-full flex flex-col padding'>
                  <h2 className='max-w-[25ch]'>Recherche & Développement (R&D) + modélisation 3D</h2>
                </div>
                <div className='grid grid-cols-2 lg:grid-cols-2 lg:min-h-[150svh] lg:h-fit gap-6 paddingX w-full relative *:h-auto  *:border *:border1'>
                  <Media src={require('./assets/bubbles.jpg')} />
                  <Media src={require('./assets/prevs/JWO_ELixir_Bubbles_PREV.mp4')} />
                  <Media src={require('./assets/prevs/10_In box_tk02.mp4')} className={"!aspect-square"} />
                  <Media src={require('./assets/prevs/Jewoh_ENV03_SCN01_Cloth_0004_Stage_a.mp4')} className={"!aspect-square"} />
                  <Media src={require('./assets/prevs/Jewoh_ENV06_OilDrops_SCN07_Cam02_1_a0056.jpg')} />
                  <Media src={require('./assets/prevs/preview.mp4')} />

                </div>
              </Section>

              <Section className={"items-center w-full lg:pt-44 bg-transparent"}>

                <div className='text-left w-full flex flex-col padding'>
                  <h2 className='max-w-[25ch]'>Rendus 3D pour contenu digital
                    <h4 className='dim muted'>
                      composés de photos de produits inédites aliant créativité, qualité et attrait commercial.. les raisons pour lesquels nos clients brillent.
                    </h4>
                  </h2>
                </div>

                <div className='grid grid-cols-2 lg:grid-cols-2 lg:min-h-[100svh] pb-20= gap-6 paddingX w-full relative h-auto= '>
                  <Media src={require('./assets/bubbles.jpg')} />
                  <Media src={require('./assets/renders/Jewoh_ENV04_Desert_SCN03_Cam02_4_a0054.jpg')} />
                  <Media src={require('./assets/renders/Jewoh_ENV04_Desert_SCN05_R09.jpg')} />
                  <Media src={require('./assets/renders/JWO_Elixir_R010.jpg')} />
                  <Media src={require('./assets/prevs/Jewoh_ENV04_Desert_SCN03_Cam02_4__a.mp4')} />
                  <Media src={require('./assets/renders/R00015.jpg')} />
                  <Media src={require('./assets/renders/R00011.jpg')} />
                  <Media src={require('./assets/renders/R00012_.jpg')} />
                </div>
              </Section>
            </div>
          </div>

          <Section padded center>
            <Media src={require('./assets/renders/JWO_Kit_Box_R001.jpg')} />
            <Media src={require('./assets/packshot.jpg')} />
          </Section>
        </div>
      )}
    </ThisProject>
  )
}

export default Content